module.exports = __webpack_public_path__ + "img/089.8dbf6db4.png";